import * as index_html from './index.html'
import * as app_js from './app.js'
import * as main_js from './main.js'
import * as paymentForm_js from './paymentForm.js'
import * as paymentForm_module_css from './paymentForm.module.css'

export default [
  index_html,
  app_js,
  main_js,
  paymentForm_js,
  paymentForm_module_css,
]
